import { useContext } from 'react';
import { CaruselContext } from '../carusel-context';
import './Page.css';

export const Page = ({ children }) => {
    const { width } = useContext(CaruselContext)

    return (
        <div className='page__main-container' style={{ minWidth: `${width}px`, maxWidth: `${width}px` }}>{children}</div>
    )
}